import SimpleContent from "components/Structure/ModalManager/SimpleContent";
import Button from "components/Elements/Button/Button";
import { useContent } from "contexts/contentContext/contentContext";
import { useModal } from "contexts/modalContext/modalContext";

interface IChangeChunkSizeModal {
  fileSize: number;
  onCancel: () => void;
  setChunkSize: (size: number) => void;
}

const ChangeChunkSizeModal = ({
  fileSize,
  onCancel,
  setChunkSize,
}: IChangeChunkSizeModal) => {
  const { getTextByKey } = useContent();
  const { closeModal } = useModal();

  const handleChangeChunkSize = () => {
    const chunkSize = Math.ceil(fileSize / 10000);
    setChunkSize(chunkSize);
    closeModal();
  };

  const handleCancel = () => {
    onCancel();
    closeModal();
  };

  return (
    <SimpleContent
      title="limit-file-size-title"
      message="limit-file-size-text"
      exitButton={
        <Button onClick={handleCancel}>
          {getTextByKey("limit-file-size-cancel")}
        </Button>
      }
      actionButton={
        <Button onClick={handleChangeChunkSize}>
          {getTextByKey("limit-file-size-ok")}
        </Button>
      }
    />
  );
};

export default ChangeChunkSizeModal;
